import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme } from 'presto-mini-apps-lib';

class ErrorMessage extends Component {
    render() {
        const {
            message, 
            isHTML, 
            children 
        } = this.props;
        return (
            <ErrorMessageWrapper className="error-message">
                <span className="icon">
                    <PrestoAppTheme.images.InfoIcon 
                        color={colorOrange} 
                        textColor={PrestoAppTheme.colors.white} 
                    />
                </span>
                {!!isHTML 
                    ? <span className="text">{children}</span>
                    : <span className="text" dangerouslySetInnerHTML={{__html: message}} />
                }
            </ErrorMessageWrapper> 
        );
    }
};

export default ErrorMessage;


const colorOrange = '#FE8F27'; // NOTE: not sure to include this into standard color yet
const errorIconSize = '14px'; 
const ErrorMessageWrapper = styled.div`
    display: flex;
    margin-top: ${PrestoAppTheme.layout.smallGap};
    justify-content: space-between;
    color: ${colorOrange};
    font-weight: 400;

    & .icon {
        display: inline-block;
        height: ${errorIconSize};
        width: ${errorIconSize};
        margin-top: 0.125rem;
        border: 1px solid ${colorOrange};
        border-radius: 100%;
    }

    & .text {
        display: inline-block;
        width: calc(100% - ${errorIconSize} - ${PrestoAppTheme.layout.smallGap});

        & .link {
            color: ${PrestoAppTheme.colors.baseBlue};
            cursor: pointer;
        }
    }
`;
